import React, { createContext, useContext, ReactNode } from 'react';
import { optumTheme, Theme } from './theme';
import { ThemeProvider as AbyssThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';

const ThemeContext = createContext<Theme>(optumTheme);

interface ThemeProviderProps {
  children: ReactNode;
}

const abyssTheme = createTheme('optum');

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <AbyssThemeProvider theme={abyssTheme}>
      <ThemeContext.Provider value={optumTheme}>
        {children}
      </ThemeContext.Provider>
    </AbyssThemeProvider>
  );
};

export const useTheme = (): Theme => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
